<div class="component-container">
  <div
    class="w-full flex flex-col flex-wrap md:flex-row md:gap-x-[2rem] justify-start items-center">
    <app-search-on-select
      (checkForErrors)="checkForErrors($event)"
      (onNextPage)="clientsOnNextPage()"
      [enableClearSelection]="true"
      [enableMultiple]="true"
      [error]="errorMessages['clientId']"
      [hasNext]="clientOptions.hasNext"
      [loading]="clientOptions.loading"
      [options]="clientOptions.list"
      [parentFormGroup]="form"
      class="input md:w-[25%] md:min-w-[25%] lg:w-[15%] lg:min-w-[15%] w-full flex-grow"
      controlName="clientId"
      filterControlName="searchClient"
      label="Organization"
      optionsPanelClassName="clients-dropdown"
      placeholder="Select all that apply"
      type="small"
    ></app-search-on-select>
    <app-search-on-select
      (checkForErrors)="checkForErrors($event)"
      (onNextPage)="groupOnNextPage()"
      [enableClearSelection]="true"
      [enableMultiple]="true"
      [error]="errorMessages['groupId']"
      [hasNext]="groupOptions.hasNext"
      [loading]="groupOptions.loading"
      [options]="groupOptions.list"
      [parentFormGroup]="form"
      class="input md:w-[25%] md:min-w-[25%] lg:w-[15%] lg:min-w-[15%] w-full flex-grow"
      controlName="groupId"
      filterControlName="searchGroup"
      label="Group"
      optionsPanelClassName="clients-dropdown"
      placeholder="Select all that apply"
      type="small"
    ></app-search-on-select>
    <app-dropdown
      (checkForErrors)="checkForErrors($event)"
      [enableClearSelection]="true"
      [enableMultiple]="true"
      [error]="errorMessages['role']"
      [options]="roleFilterList"
      [parentFormGroup]="form"
      class="input md:w-[25%] md:min-w-[25%] lg:w-[15%] lg:min-w-[15%] w-full flex-grow"
      controlName="role"
      label="Role"
      placeholder="Select all that apply"
      type="small"
    />
    <app-dropdown
      (checkForErrors)="checkForErrors($event)"
      [enableClearSelection]="true"
      [enableMultiple]="true"
      [error]="errorMessages['status']"
      [options]="statusFilterList"
      [parentFormGroup]="form"
      class="input md:w-[25%] md:min-w-[25%] lg:w-[15%] lg:min-w-[15%] w-full flex-grow"
      controlName="status"
      label="Status"
      placeholder="Select all that apply"
      type="small"
    />
    <div class="vertical hidden md:block"></div>
    <app-text-input
      (checkForErrors)="checkForErrors($event)"
      (handleSuffixClick)="apply()"
      [error]="errorMessages['searchText']"
      [minLength]="0"
      [parentFormGroup]="form"
      class="input w-full md:w-[25%] md:min-w-[25%] lg:w-[15%] lg:min-w-[15%] search-input flex-grow"
      controlName="searchText"
      label="Search"
      placeholder="Search"
      suffixIcon="search"
      type="small"
    ></app-text-input>
    <div class="vertical hidden md:block"></div>
    <app-primary-button
      (handleClick)="apply()"
      [isDisabled]="!form.dirty"
      class="btn lg:w-[10%] md:w-[10%] w-full flex-grow"
      type="small"
    >
      Apply
    </app-primary-button>
  </div>
</div>
